export default __webpack_public_path__ + "static/araby-2ec90452dd1310eec2575c8b84278b66.webp";